import { render, staticRenderFns } from "./RatesTable.vue?vue&type=template&id=cba6eff2&scoped=true"
import script from "./RatesTable.vue?vue&type=script&lang=ts"
export * from "./RatesTable.vue?vue&type=script&lang=ts"
import style0 from "./RatesTable.vue?vue&type=style&index=0&id=cba6eff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba6eff2",
  null
  
)

export default component.exports